import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/style.css';
import HomeContent from './page/Home';
import HeaderContent from './common/Header';
import FooterContent from './common/Footer';
import BackToTop from './common/backTotop';
import AboutContent from './page/About';
import ManagerPage from './page/Manager';
import FounderPage from './page/Founder';
import ContactContainer from './page/Contact';
import VisionMission from './page/Vision';
import OurStory from './page/OurStory';
import Principal from './page/Principal';
import Branches from './page/Branches';
import ClassRoom from './page/ClassRoom';
import ComputerLab from './page/ComputerLab';
import ScienceLab from './page/ScienceLab';
import MathsLab from './page/MathsLab';
import Library from './page/Library';
// import ActivityRoom from './page/ActivityRoom';
import MusicRoom from './page/MusicRoom';
import SmartClass from './page/SmartClass';
import Transportation from './page/Transportation';
import SafetySecurity from './page/SafetySecurity';
import AdmissionProcedure from './page/AdmissionProcedure';
import FeeStructure from './page/FeeStructure';
import Prospectus from './page/Prospectus';
import Uniform from './page/Uniform';
import Club from './page/Club';
import StudentCouncil from './page/StudentCouncil';
import Testimonials from './page/Testimonials';
import OurAlumni from './page/OurAlumni';
import TransferCertificate from './page/TransferCertificate';
import Syllabus from './page/Syllabus';
import BookList from './page/BookList';
import PhotoGallery from './page/PhotoGallery';
import VideoGallery from './page/VideoGallery';
import MediaGallery from './page/MediaGallery';
import OurAchievements from './page/OurAchievements';
import ToppersX from './page/ToppersX';
import ToppersXII from './page/ToppersXII';
import MandatoryPublic from './page/MandatoryPublic';
import Auditorium from './page/Auditorium';
import BiologyPhoto from './page/BiologyPhoto';
import BuildingPhoto from './page/BuildingPhoto';
import LibraryPhoto from './page/LibraryPhoto';
import LabPhoto from './page/LabPhoto';
import MathematicsPhoto from './page/MathematicsPhoto';
import RoboticsPhoto from './page/RoboticsPhoto';
import AIPhoto from './page/AIPhoto';
import Robotics from './page/Robotics';
import BasantPanchami from './page/BasantPanchami';
import SOF from './page/SOF';
import DistrictScout from './page/DistrictScout';
import Winners from './page/Winners';
import SarojiniNagarSport from './page/SarojiniNagarSport';
import Conclave from './page/Conclave';
import BiologyLab from './page/BiologyLab';
import PhysicsLab from './page/PhysicsLab';
import Activities from './page/Activities';
import CreativeArtCraftRoom from './page/CreativeArtCraftRoom';
import HappyLohri from './page/HappyLohri';
import Scouts from './page/Scouts';
import Farewell from './page/Farewell';
import RebublicDay from './page/RebublicDay';
import GeographyLab from './page/GeographyLab';

function App() {
  return (
    <>
      <div>
          <BrowserRouter>
              <HeaderContent />
              <Routes>
                <Route path="/" element={<HomeContent />} /> 
                <Route path='/About' element={<AboutContent />} />    
                <Route path='/Manager' element={<ManagerPage />} />      
                <Route path='/Founder' element={<FounderPage />} />   
                <Route path='/Contact' element={<ContactContainer />} />  
                <Route path='/Vision' element={<VisionMission />} /> 
                <Route path='/OurStory' element={<OurStory />} />    
                <Route path='/Principal' element={<Principal />} />   
                <Route path='/Branches' element={<Branches />} />   
                <Route path='/MandatoryPublic' element={<MandatoryPublic />} />   
                <Route path='/modern-class-room' element={<ClassRoom />} />
                <Route path='/advanced-computer-laboratory' element={<ComputerLab />} />
                <Route path='/advanced-chemistry-laboratory' element={<ScienceLab />} />
                <Route path='/advanced-biology-laboratory' element={<BiologyLab />} />
                <Route path='/advanced-physics-laboratory' element={<PhysicsLab />} />
                <Route path='/interactive-mathematics-lab' element={<MathsLab />} />
                <Route path='/rich-quiet-library' element={<Library />} />
                {/* <Route path='/creative-activity-room' element={<ActivityRoom />} /> */}
                <Route path='/dedicated-music-room' element={<MusicRoom />} />
                <Route path='/digital-smart-classrooms' element={<SmartClass />} />
                <Route path='/safe-school-transportation' element={<Transportation />} />
                <Route path='/247-safety-cctv-surveillance' element={<SafetySecurity />} />
                <Route path='/AdmissionProcedure' element={<AdmissionProcedure />} />
                <Route path='/FeeStructure' element={<FeeStructure />} />
                <Route path='/Prospectus' element={<Prospectus />} />
                <Route path='/Uniform' element={<Uniform />} />
                <Route path='/Club' element={<Club />} />
                <Route path='/StudentCouncil' element={<StudentCouncil />} />
                <Route path='/Testimonials' element={<Testimonials />} />
                <Route path='/OurAlumni' element={<OurAlumni />} />
                <Route path='/TransferCertificate' element={<TransferCertificate />} />
                <Route path='/Syllabus' element={<Syllabus />} />
                <Route path='/BookList' element={<BookList />} />
                <Route path='/PhotoGallery' element={<PhotoGallery />} />    
                <Route path='/VideoGallery' element={<VideoGallery />} />
                <Route path='/MediaGallery' element={<MediaGallery />} />
                <Route path='/OurAchievements' element={<OurAchievements />} />
                <Route path='/ToppersX' element={<ToppersX />} />
                <Route path='/ToppersXII' element={<ToppersXII />} />
                <Route path='/Auditorium' element={<Auditorium />} />
                <Route path='/BiologyPhoto' element={<BiologyPhoto />} />
                <Route path='/BuildingPhoto' element={<BuildingPhoto />} />
                <Route path='/LibraryPhoto' element={<LibraryPhoto />} />
                <Route path='/LabPhoto' element={<LabPhoto />} />
                <Route path='/MathematicsPhoto' element={<MathematicsPhoto />} />
                <Route path='/RoboticsPhoto' element={<RoboticsPhoto />} />
                <Route path='/AIPhoto' element={<AIPhoto />} />
                 <Route path='/ai-robotics-lab' element={<Robotics />} />
                 <Route path='/BasantPanchami' element={<BasantPanchami />} />
                 <Route path='/SOF' element={<SOF />} />
                 <Route path='/DistrictScout' element={<DistrictScout />} />
                 <Route path='/Winners' element={<Winners />} />
                 <Route path='/SarojiniNagarSport' element={<SarojiniNagarSport />} />
                 <Route path='/Conclave' element={<Conclave />} />
                 <Route path='/Activities' element={<Activities />} />
                 <Route path='/creative-art-craft-room' element={<CreativeArtCraftRoom />} />
                  <Route path='/HappyLohri' element={<HappyLohri />} />
                   <Route path='/Scouts' element={<Scouts />} />
                    <Route path='/Farewell' element={<Farewell />} />
                     <Route path='/RebublicDay' element={<RebublicDay />} />
                     <Route path='/geography-lab' element={<GeographyLab />} />
              </Routes>
              <FooterContent />
              <BackToTop />
          </BrowserRouter>
        </div>
    </>
  );
}

export default App;
